// extracted by mini-css-extract-plugin
export default {"modalContainer":"GlobalModal_modalContainer__9Wm2q","globalModalWrapper":"GlobalModal_globalModalWrapper__fgsMS","hidden":"GlobalModal_hidden__w9jFJ"};